module.exports = __webpack_public_path__ + "img/dp-bg.48eb7c19.png";